(function(){
  function init(ctx){
    (ctx||document).querySelectorAll('[data-fx-slider]').forEach(function(s){
      if(s.dataset.ready)return;
      var track=s.querySelector('[data-fx-track]');if(!track)return;
      s.dataset.ready='1';
      var items=[].slice.call(track.children);
      var prev=s.querySelector('[data-fx-prev]'),next=s.querySelector('[data-fx-next]'),dw=s.querySelector('[data-fx-dashes]');
      var dashes=[];
      function step(){return items.length>1?items[1].offsetLeft-items[0].offsetLeft:track.clientWidth}
      function pages(){var st=step();if(!st)return 1;var vis=Math.max(1,Math.round(track.clientWidth/st));return Math.max(1,items.length-vis+1)}
      function build(){if(!dw)return;var c=pages();if(dashes.length===c)return;dw.innerHTML='';dashes=[];
        for(var i=0;i<c;i++){(function(i){var b=document.createElement('button');b.type='button';b.className='fx-dash';b.setAttribute('aria-label',String(i+1));
          b.addEventListener('click',function(){track.scrollTo({left:i*step(),behavior:'smooth'})});dw.appendChild(b);dashes.push(b)})(i)}}
      function update(){var st=step()||1,c=pages(),max=track.scrollWidth-track.clientWidth;
        var idx=Math.min(c-1,Math.max(0,Math.round(track.scrollLeft/st)));if(max>4&&max-track.scrollLeft<4)idx=c-1;
        dashes.forEach(function(d,i){d.classList.toggle('is-active',i===idx)});
        if(prev)prev.disabled=track.scrollLeft<4;if(next)next.disabled=max-track.scrollLeft<4;
        s.classList.toggle('is-static',max<4)}
      if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step()})});
      if(next)next.addEventListener('click',function(){track.scrollBy({left:step()})});
      track.addEventListener('scroll',function(){requestAnimationFrame(update)},{passive:true});
      window.addEventListener('resize',function(){build();update()});
      /* Dra med mus (dator / redigerarens mobilvy) */
      var down=false,sx=0,sl=0,moved=false;
      track.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;sx=e.clientX;sl=track.scrollLeft;track.classList.add('is-dragging')});
      window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>3)moved=true;track.scrollLeft=sl-dx});
      window.addEventListener('pointerup',function(){if(!down)return;down=false;track.classList.remove('is-dragging');var st=step()||1;track.scrollTo({left:Math.round(track.scrollLeft/st)*st,behavior:'smooth'})});
      track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false}},true);
      track.addEventListener('dragstart',function(e){e.preventDefault()});
      build();update();
    });
  }
  window.fxInit=init;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
